import React from 'react';
import { BoxImage, CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="bg-navy px-3 py-4 text-center sm:px-6" data-id="element-51" data-mp="3ucx67lwhbz2d">
      <div className="mx-auto max-w-xl" data-id="element-52" data-mp="3uei3hja6hw3x">
        <h2 className="font-heading text-[1.1rem] font-extrabold uppercase leading-tight text-white sm:text-[1.7rem]" data-id="element-53" data-mp="c70yncel7jpm">
          One last question
        </h2>
        <p className="mt-1 text-[0.78rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-54" data-mp="87jrmejiieic">
          When another radiology image appears... Do you immediately know what
          you're looking at and where to start? Stop jumping between scattered
          resources and trying to memorize radiology from text alone. Open the
          atlas. Identify the modality. Follow the visual references.
        </p>
        <p className="mt-1 font-body text-[0.72rem] font-extrabold uppercase tracking-wide text-gold sm:text-[0.86rem]" data-id="element-55" data-mp="14vfyust27xgw">
          See. Compare. Recognize.
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[220px] sm:max-w-[270px]" target="checkout" data-id="element-56" data-mp="zy6dbo8sk5yc" />

        <p className="mt-2 font-heading text-[1.05rem] font-extrabold uppercase text-white sm:text-[1.5rem]" data-id="element-57" data-mp="2c7125zb2erve">
          🩻 Radiology Visual Atlas™
        </p>
        <p className="mt-0.5 font-body text-[0.68rem] font-bold uppercase tracking-wide text-white/80 sm:text-[0.8rem]" data-id="element-58" data-mp="2m21d0w4omm1w">
          The Complete Visual Study System for Radiology Students
        </p>
        <p className="mt-0.5 font-body text-[0.64rem] font-bold uppercase tracking-[0.14em] text-radio sm:text-[0.74rem]" data-id="element-59" data-mp="2v2r5pqynbwbe">
          Orient • Understand • Compare • Identify • Recognize • Review
        </p>

        <div className="mx-auto mt-2 max-w-md" data-id="element-60" data-mp="34tu3ojwa3v6g">
          <p className="font-body text-[0.76rem] font-extrabold uppercase tracking-wide text-gold sm:text-[0.9rem]" data-id="element-61" data-mp="39s5diumkq5oo">
            🔥 Get the complete system today
          </p>
          <div className="mt-1.5" data-id="element-62" data-mp="3eporruj9uigm">
            <CTAButton label="⚡ Get Radiology Visual Atlas™" target="checkout" data-id="element-63" data-mp="3isld3t074so9" />
          </div>
          <p className="mt-1.5 font-body text-[0.62rem] font-bold uppercase tracking-wide text-white/75 sm:text-xs" data-id="element-64" data-mp="1jov19uiv8edy">
            Immediate Access • Digital Delivery 🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}